module.exports = __webpack_public_path__ + "img/0040020-PS2.0d7b0a17.jpg";